<template>
  <div
    class="c-popover"
    @mousemove.capture="handleMouseMove"
  >
    <div @mouseenter="fixPosition">
      <slot name="wrapper"></slot>
    </div>
    <div
      ref="content"
      class="c-popover__content"
      :style="contentStyles"
    >
      <slot
        name="content"
        :position="{ left, top }"
      ></slot>
    </div>
  </div>
</template>
<script>
  // TODO FIX RESIZE PROBLEM!!

  export default {
    name: 'UiPopover',
    props: {
      center: {
        type: Boolean,
        default: false,
      },
      additionalOffset: {
        type: Number,
        default: 10,
      },
    },
    data() {
      return {
        top: 0,
        left: 0,
        horizontalOffset: 0,
      };
    },
    computed: {
      contentStyles() {
        if (this.center) {
          return { transform: `translate3d(calc(-50% - ${this.horizontalOffset}px), 0, 0)` };
        }
        return { transform: `translate3d(${this.left}px, 0, 0)` };
      },
    },
    methods: {
      handleMouseMove(e) {
        const wrapper = e.currentTarget;
        if (!wrapper) {
          return;
        }
        if (this.rAF) {
          window.cancelAnimationFrame(this.rAF);
        }
        this.rAF = window.requestAnimationFrame(() => {
          const rect = wrapper.getBoundingClientRect();
          this.left = e.clientX - rect.left;
          this.top = e.clientY - rect.top;
          if (this.left >= 0 && this.top >= 0) {
            this.$emit('hover', {
              top: this.top,
              left: this.left,
              offsetWidth: this.$el.offsetWidth,
            });
          }
        });
      },
      fixPosition() {
        const elm = this.$refs.content;
        if (!elm) {
          return;
        }

        const rect = elm.getBoundingClientRect();
        const position = {
          // comment for further improvements
          // top: rect.top,
          // left: rect.left,
          // bottom: (window.innerHeight || document.documentElement.clientHeight) - rect.bottom,
          right: (window.innerWidth || document.documentElement.clientWidth) - rect.right,
        };
        if (position.right < 0) {
          this.horizontalOffset = Math.abs(position.right - this.additionalOffset);
        }
      },
    },
  };
</script>
